'use client';

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,  } from 'recharts';

const uploadData = [
  { month: 'Nov', documents: 8, artifacts: 3 },
  { month: 'Dec', documents: 5, artifacts: 1 },
  { month: 'Jan', documents: 14, artifacts: 4 },
  { month: 'Feb', documents: 11, artifacts: 6 },
  { month: 'Mar', documents: 19, artifacts: 8 },
  { month: 'Apr', documents: 18, artifacts: 5 },
  { month: 'May', documents: 17, artifacts: 6 },
];

const CustomTooltip = ({ active, payload, label }: {
  active?: boolean;
  payload?: Array<{ name: string; value: number; color: string }>;
  label?: string;
}) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="masonic-card p-3 text-sm"
        style={{ minWidth: 160 }}
      >
        <p className="font-serif font-semibold mb-2" style={{ color: 'var(--foreground)' }}>
          {label} 2025–26
        </p>
        {payload.map((entry) => (
          <div key={`tt-${entry.name}`} className="flex items-center justify-between gap-4">
            <span className="flex items-center gap-1.5" style={{ color: 'var(--muted-foreground)' }}>
              <span
                className="w-2.5 h-2.5 rounded-sm inline-block"
                style={{ background: entry.color }}
              />
              {entry.name}
            </span>
            <span className="font-semibold tabular-nums" style={{ color: 'var(--foreground)' }}>
              {entry.value}
            </span>
          </div>
        ))}
        <div
          className="mt-2 pt-2 flex justify-between font-semibold"
          style={{ borderTop: '1px solid var(--border)' }}
        >
          <span style={{ color: 'var(--muted-foreground)' }}>Total</span>
          <span style={{ color: 'var(--foreground)' }}>
            {payload.reduce((s, e) => s + e.value, 0)}
          </span>
        </div>
      </div>
    );
  }
  return null;
};

export default function DashboardUploadChart() {
  return (
    <div className="masonic-card p-6 h-full">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h2 className="font-serif text-lg font-semibold" style={{ color: 'var(--foreground)' }}>
            Archive Intake Volume
          </h2>
          <p className="text-sm mt-1" style={{ color: 'var(--muted-foreground)' }}>
            Records added to the archive by month — Nov 2025 to May 2026
          </p>
        </div>
        <div
          className="text-xs px-2.5 py-1 rounded-full font-medium"
          style={{ background: 'var(--success-bg)', color: 'var(--success)' }}
        >
          +27% vs prior period
        </div>
      </div>

      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={uploadData} barGap={4} barCategoryGap="30%">
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="var(--border)"
            vertical={false}
          />
          <XAxis
            dataKey="month"
            tick={{ fontSize: 12, fill: 'var(--muted-foreground)', fontFamily: 'var(--font-dm-sans)' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 12, fill: 'var(--muted-foreground)', fontFamily: 'var(--font-dm-sans)' }}
            axisLine={false}
            tickLine={false}
            width={28}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(27, 42, 74, 0.04)' }} />
          <Legend
            wrapperStyle={{
              fontSize: 12,
              fontFamily: 'var(--font-dm-sans)',
              color: 'var(--muted-foreground)',
              paddingTop: 16,
            }}
          />
          <Bar dataKey="documents" name="Documents" fill="var(--primary)" radius={[3, 3, 0, 0]} />
          <Bar dataKey="artifacts" name="Artifacts" fill="var(--accent)" radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}